<template>
  <div class="px-4 pb-4 sm:px-6 sm:pb-6">
    <h1 class="my-2">
      {{ t("headings.create_partner") }}
    </h1>
    <breadcrumb class="mt-3 mb-4" />
    <div v-if="formElements" class="card grid p-4">
      <custom-form
        :formElements="formElements"
        formStyle="inline"
        @submitForm="createPartner"
      />
    </div>
  </div>
</template>

<script>
import { computed, onMounted, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import Breadcrumb from "../components/breadcrumb/Breadcrumb.vue";
import CustomForm from "../components/form/CustomForm.vue";
import { getISODate } from "../utils/dateUtils";
export default {
  components: { Breadcrumb, CustomForm },
  props: {},
  setup() {
    const route = useRoute();
    const store = useStore();
    const { t } = useI18n();

    const types = computed(() => store.state.partner.types);

    const formElements = ref(null);

    const setFormElements = () => {
      formElements.value = [
        {
          class:
            "col-span-12 md:col-span-10 lg:col-span-9 xl:col-span-7 sm:px-2",
          element: "input",
          id: "name",
          label: "name",
          rules: ["isRequired"],
          type: "text",
          value: "",
          variable: "name",
        },
        {
          class:
            "col-span-12 md:col-span-10 lg:col-span-9 xl:col-span-7 sm:px-2",
          element: "datepicker",
          id: "licence-date",
          label: "licence_validity",
          rules: ["isRequired"],
          textVariant: "white",
          value: getISODate(new Date()),
          variable: "licenceValidity",
          variant: "indigo",
        },
        {
          class:
            "col-span-12 md:col-span-10 lg:col-span-9 xl:col-span-7 sm:px-2",
          element: "multiselect",
          id: "type-multiselect",
          label: "type",
          optionLabel: ["label"],
          options: types.value,
          rules: ["isRequired"],
          translatableLabel: "partner_types",
          value: [],
          variable: "types",
        },
        {
          class:
            "col-span-12 md:col-span-10 lg:col-span-9 xl:col-span-7 sm:px-2",
          element: "input",
          id: "email",
          label: "email",
          rules: ["isRequired", "isEmail"],
          type: "text",
          value: "",
          variable: "email",
        },
        {
          class:
            "col-span-12 md:col-span-10 lg:col-span-9 xl:col-span-7 sm:px-2",
          element: "input",
          id: "phone",
          label: "phone",
          rules: ["isRequired", "isPhoneNumber"],
          type: "text",
          value: "",
          variable: "phone",
        },
        {
          class: "col-span-12 text-right",
          element: "button",
          id: "submit-button",
          label: "save",
          textVariant: "white",
          type: "submit",
          variant: "indigo",
        },
      ];
    };

    const createPartner = (data) => {
      data.primary = {
        50: "#eef2ff",
        100: "#e0e7ff",
        200: "#c7d2fe",
        300: "#a5b4fc",
        400: "#818cf8",
        500: "#6366f1",
        600: "#4f46e5",
        700: "#4338ca",
        800: "#3730a3",
        900: "#312e81",
      };
      data.primaryText = "light";
      store.dispatch("partner/createPartner", data);
    };

    onMounted(() => {
      if (!types.value || !types.value.length) {
        store.dispatch("partner/getTypes");
      } else {
        setFormElements();
      }
    });

    watch(
      () => types.value,
      (types) => {
        if (types.length) {
          setFormElements();
        }
      }
    );

    return {
      getISODate,
      route,
      store,
      t,
      formElements,
      createPartner,
    };
  },
};
</script>
